import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { formatCollectionAndFieldName } from './common/common_utils';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';

export class AppwriteEdit extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    collectionsByAppwrite: [],
    collectionsByexternaldb: [],
  };
  async componentDidMount() {
    const { match, actions } = this.props;
    const { dbUuid, projectId, version } = match.params;
    await actions.loadAppwriteExternaldb({ projectId, dbUuid, version });
    await actions.collectionListExternaldbs({ projectId, dbUuid, version });
    const { setting, completeData } = this.props.dataConnector.externaldbAppwrite;
    const { database } = completeData;
    await actions.getCollectionsByAppwrite({
      settingData: setting,
      databaseId: database.id,
      projectId,
      version,
    });
    const { collectionsByAppwrite, collectionList } = this.props.dataConnector;
    this.setState({ collectionsByAppwrite: collectionsByAppwrite.collections });
    this.setState({ collectionsByexternaldb: collectionList });
  }

  handleCreateCollection = (index) => {
    const { match, history } = this.props;
    const { dbUuid, projectId, version } = match.params;
    history.push(`/data-connector/${version}/v/${projectId}/appwrite-datasource/${dbUuid}/create`, {
      collectionIndex: index,
    });
  };
  handleUpdateCollection = (item) => {
    const { match, history } = this.props;
    const { projectId, dbUuid, version } = match.params;
    history.push(
      `/data-connector/${version}/v/${projectId}/appwrite-edit/${dbUuid}/update/${item.$id}`,
    );
  };

  getOrdinalSuffix = (day) => {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    const lastDigit = day % 10;
    switch (lastDigit) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  formatDate = (date) => {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
    const day = date.getDate();
    const ordinalSuffix = this.getOrdinalSuffix(day);
    return formattedDate.replace(/\b\d+\b/, (match) => match + ordinalSuffix);
  };

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />
        </CommonPageComponent>
      );
    }
    const { collectionsByAppwrite, collectionsByexternaldb } = this.state;
    const { dataConnector } = this.props;
    const { getCollectionsByAppwritePending } = dataConnector;
    const collectionsWithDb = collectionsByexternaldb.map((a) => ({
      collectionTitle: a.collectionTitle,
      collectionName: a.collectionName,
      orgCollectionName: a.orgCollectionName,
      createdAt: a.createdAt,
      updatedAt: a.updatedAt,
    }));
    if (getCollectionsByAppwritePending) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader loading={getCollectionsByAppwritePending} size="20px" color="#303453" />
          </div>
        </CommonPageComponent>
      );
    }

    return (
      collectionsByAppwrite && (
        <CommonPageComponent>
          <ParentContentCard title={'All Collections in  Appwrite Database'} icon={'collection'}>
            <div className="grid__column">
              {collectionsByAppwrite.map((item, index) => (
                <span className={`card ml-4 card--collection-source col-lg-4`} key={index}>
                  <div className="card-body">
                    <div className="avatar__meta">
                      {collectionsWithDb.some(
                        (collection) => collection.orgCollectionName === item.name,
                      ) ? (
                        <h5 className="avatar__title js-user-name" title={item.name}>
                          {item.name} <i className={'wb webconnect-check-circle text-success'}></i>
                        </h5>
                      ) : (
                        <h5 className="avatar__title js-user-name" title={item.name}>
                          {item.name}
                        </h5>
                      )}

                      <p>Number of fields: {item.attributes.length}</p>
                      {collectionsWithDb.some(
                        (collection) => collection.orgCollectionName === item.name,
                      ) ? (
                        <div>
                          <p>
                            Created At:{' '}
                            {this.formatDate(
                              new Date(
                                collectionsWithDb.find(
                                  (collection) => collection.orgCollectionName === item.name,
                                ).createdAt,
                              ),
                            )}
                          </p>
                          <p>
                            Updated At:{' '}
                            {this.formatDate(
                              new Date(
                                collectionsWithDb.find(
                                  (collection) => collection.orgCollectionName === item.name,
                                ).updatedAt,
                              ),
                            )}
                          </p>
                        </div>
                      ) : (
                        <div>
                          <p>Created At: Not yet created</p>
                          <p>Updated At: Not yet updated</p>
                        </div>
                      )}
                    </div>

                    {collectionsWithDb.some(
                      (collection) => collection.orgCollectionName === item.name,
                    ) ? (
                      <button
                        className="btn btn-theme-submit btn-md"
                        onClick={() => this.handleUpdateCollection(item)}
                      >
                        <i className="wb webconnect-save-regular"> </i>
                        {' Update'}
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary btn-md"
                        onClick={() => this.handleCreateCollection(index)}
                      >
                        <i className="wb webconnect-plus"> </i>
                        {' Create'}
                      </button>
                    )}
                  </div>
                </span>
              ))}
            </div>
          </ParentContentCard>
        </CommonPageComponent>
      )
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppwriteEdit);
